import useContract from './useContract';
import AuctionHouse from '../contracts/AuctionHouse.json';

const useAuctionHouse = () =>
  useContract(
    process.env.NEXT_PUBLIC_AUCTION_HOUSE_CONTRACT_ADDRESS,
    AuctionHouse.abi
  );

export default useAuctionHouse;
